import { CancellationReason, IOrderInfo } from "../rxAutoMessages/rxAutoMessages";
import { ISortBoxModel } from "../sortbox/ISortBoxModel";
import { ISortBoxItemModel } from "../SortBoxItem/ISortBoxItemModel";
import { ActionStates } from "./ActionStates";

export const getOperatorMessage = (
  actionState: ActionStates,
  currentBox: ISortBoxModel | null,
  nextCartShelf: number,
  orderInfo: IOrderInfo | null = null,
  cancelled: boolean = false): string => {
  let message = ""
  switch (actionState) {
    case ActionStates.COMPLETE_BOX:
      if (orderInfo === null || orderInfo.NotFound && !orderInfo.BoxBarcode) {
        message = "VÄNTAR PÅ ORDER";
      } else {
        if (orderInfo.SkuPutawayRequired) {
          return "HANTERA LAGER";
        }
        else if (!orderInfo.SkuPutawayRequired && orderInfo.SortBoxes.length > 0 && orderInfo.SortBoxes.every((x) => x.Done)) {
          message = "Klarmarkera";
        }
        else if (orderInfo.NonRXOrder) {
          message = "EJ RXORDER";
        } 
        else if (orderInfo.NotFound && orderInfo.BoxBarcode) { 
          message = "INGEN ORDER FUNNEN";
        }
        else {
          message = "EXPEDIERA ORDER";
        }
      }
      break;
    case ActionStates.SET_CART:
      message = "SCANNA NY VAGN";
      break;
    case ActionStates.SCAN_SHELF_OR_CART: {
      message = "SCANNA FACK " + ((nextCartShelf > 0) ? nextCartShelf : "..")
      break;
    }
    case ActionStates.SCAN_SINGLE_ARTICLE: {
      message = "SCANNA NÅGON ARTIKEL.."
      break;
    }
    default:
      break;
  }
  return message;
};

export const getCancellationReason = (orderInfo: IOrderInfo | null | undefined) => {
  const done =
    orderInfo &&
    orderInfo.SortBoxID > 0 &&
    orderInfo.SortBoxes.length > 0 &&
    orderInfo.SortBoxes.every((sb) => sb.Done);
  if (!orderInfo) {
    return CancellationReason.undefined
  }
  if (done) {
    return CancellationReason.RxOrderComplete;
  } else if (orderInfo?.NotFound) {
    return CancellationReason.OrderNotFound;
  } else if (!done && !orderInfo?.NonRXOrder) {
    return CancellationReason.RxOrderIncomplete;
  } else if (orderInfo?.NonRXOrder) {
    return CancellationReason.NonRxOrderIncomplete;
  } else {
    return CancellationReason.undefined;
    }
}

export const sortRXOrderItems = (bagBoxItems: ISortBoxItemModel[][], orderInfo: IOrderInfo | null,
  parentSortBoxID: number | undefined, currentSortBoxID: number | undefined) => {

  for (let items of bagBoxItems) {
    items.sort((i1, i2) => {
      if (i1.verifiedQuantity > i2.verifiedQuantity && i1.verifiedQuantity !== i1.reservedQuantity) {
        return -1;
      }

      if (i2.verifiedQuantity > i1.verifiedQuantity && i2.verifiedQuantity !== i2.reservedQuantity) {
        return 1;
      }

      if (Math.abs(i2.verifiedQuantity - i2.reservedQuantity) < Math.abs(i1.verifiedQuantity - i1.reservedQuantity)) {
        return -1;
      }

      if (Math.abs(i2.verifiedQuantity - i2.reservedQuantity) > Math.abs(i2.verifiedQuantity - i1.reservedQuantity)) {
        return 1;
      }
      return 0;
    });
  }

  bagBoxItems.sort((l1, l2) => {
    if (l1.some(i => i.boxID === currentSortBoxID)) {
      return -1;
    }
    if (l2.some(i => i.boxID === currentSortBoxID)) {
      return 1;
    }

    if (l1.some(i => i.boxID === parentSortBoxID)) {
      return 1;
    }
    if (l2.some(i => i.boxID === parentSortBoxID)) {
      return -1;
    }

    if (l1.every(i => i.reservedQuantity === i.verifiedQuantity) && l1.some(i => orderInfo?.SortBoxes.some(sb => sb.SortBoxID === i.boxID))) {
      return 1;
    }

    if (l2.every(i => i.reservedQuantity === i.verifiedQuantity) && l2.some(i => orderInfo?.SortBoxes.some(sb => sb.SortBoxID === i.boxID))) {
      return -1;
    }

    return 0
  })
}
